import {Flex, Box} from '@chakra-ui/react'

import LogoQantasBusinessRewards from '~/react/components/Logo/LogoQantasBusinessRewards'
import LogoHorizontal from '~/react/components/Logo/LogoHorizontal'

const Logos = () => (
  <Box borderTop="1px solid" py="md">
    <Flex direction="row" gap="md" alignItems="center">
      <Box>
        <LogoHorizontal width={150} height={50} />
      </Box>
      <Box borderLeft="1px solid" pl="md">
        <LogoQantasBusinessRewards width={150} height={50} />
      </Box>
    </Flex>
  </Box>
)

export default Logos
